import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";
import BugsnagPerformance from "@bugsnag/browser-performance";

// Initialize Bugsnag
Bugsnag.start({
  apiKey: "4cb2ac987d43be39946f24b7cfece996",
  plugins: [new BugsnagPluginReact()],
  // Add additional configuration options
  appVersion: import.meta.env.VITE_APP_VERSION || "1.0.0",
  releaseStage: import.meta.env.MODE || "development",
  enabledReleaseStages: ["production", "staging"],
  // Enable automatic error reporting
  autoDetectErrors: true,
  autoTrackSessions: true,
  // Configure user context
  onError: (event) => {
    // Add any custom error handling here
    // Console log removed for production builds
  },
});

// Initialize Bugsnag Performance only in production/staging
if (import.meta.env.MODE === "production" || import.meta.env.MODE === "staging") {
  BugsnagPerformance.start({
    apiKey: "4cb2ac987d43be39946f24b7cfece996",
    // Enable performance monitoring
    autoInstrumentNetworkRequests: true,
    autoInstrumentPageLoad: true,
    autoInstrumentPageVisibility: true,
  });
}

export default Bugsnag;
